import { LinkWithChevron } from '#components/Link/LinkWithChevron';
import { useEnvironment } from '#cutils/context/EnvironmentContext';

import { SingleColumnLayout } from '../SingleColumnLayout/SingleColumnLayout';
import { SocialMediaSharer } from '../SocialMediaSharer';

import { NewsPlayer } from './NewsPlayer';
import { ShortNewsArticlesLinks } from './ShortNewsArticlesLinks';
import styles from './ShortnewsDetail.module.scss';
import type { NewsAudioFragment } from './__generated__/Shortnews.generated';
import type { ShortnewsArticleFragment } from './fragments/__generated__/ShortnewsArticle.generated';

type Props = {
	byEditorialTeam: string;
	id: string;
	omId: string | null | undefined;
	path: string | null | undefined;
	shareUrl: string | null | undefined;
	text: string | null | undefined;
	title: string | null | undefined;
	updateDate: string | null;
	shortNewsList: Omit<ShortnewsArticleFragment, '__typename'>[];
	newsAudio: NewsAudioFragment | null;
};

export function ContentPageShortnewsDetail({ updateDate, byEditorialTeam, id, shareUrl, text, title, shortNewsList, newsAudio }: Props) {
	const {
		constants: { appUrl },
	} = useEnvironment();
	const validatedShareUrl = !!shareUrl ? shareUrl : `${appUrl}/meldung`;

	const source = `Sendung: ${byEditorialTeam}, ${updateDate}`;

	return (
		<SingleColumnLayout contentClassName={styles.content}>
			<article id={id} key={id}>
				<h1 className={styles.title}>{title}</h1>

				<p className="body3">{text}</p>

				<p className={`${styles.source} heading4`}>{source}</p>

				<SocialMediaSharer className={styles.sharer} commentId={undefined} direction="horizontal" url={validatedShareUrl} />

				<h2 className={styles.shortnewsTitle}>Weitere Meldungen</h2>
				<ShortNewsArticlesLinks shortNewsList={shortNewsList} />
				<NewsPlayer className={styles.player} audio={newsAudio} />

				<LinkWithChevron className={`heading3 ${styles.homepageLink}`} href="/">
					Zur BR24 Startseite
				</LinkWithChevron>
			</article>
		</SingleColumnLayout>
	);
}
